import { apiClient } from './client'
import { ApiError } from './errors'

export async function requestWithdrawal(data: {
  amount: number
  bankAccountId: number
}): Promise<{ id: number }> {
  try {
    const response = await apiClient.post<{ id: number }>('withdrawals', {
      amount: data.amount,
      bank_account_id: data.bankAccountId
    })
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function fetchWithdrawalHistory(): Promise<
  Array<{ id: number; amount: number; status: string; createdAt: string }>
> {
  try {
    const response = await apiClient.get<
      Array<{ id: number; amount: number; status: string; createdAt: string }>
    >('withdrawals/history')
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}
